import { get } from "lodash";
import React from "react";

import apis from "../../services/Admin";

class ConsultaImei extends React.Component {
  state = {
    imeiDisp: "",
    dispositivos: [],

    error404: "",
  };

  changeList = (event) => {
    event.preventDefault();
    this.setState({ showList: !this.state.showList });
  };

  renderList = () => {
    const list = this.state.dispositivos[0] || [];
    return list.map((dispositivo, index) => (
      <tr key={index}>
        <td>{dispositivo.imei}</td>
        <td>
          <a href className="text-link" onClick={() => this.props.userInfo(dispositivo.user)}>
            {dispositivo.user.cpf}
          </a>
        </td>
        <td>{dispositivo.marca}</td>
        <td>{dispositivo.modelo}</td>
        <td>{dispositivo.situacao}</td>
      </tr>
    ));
  };

  onConsultar = async (event) => {
    event.preventDefault();

    this.setState({ error404: "" });
    await apis
      .loadDispositivosByImei(this.state.imeiDisp)
      .then((resp) => {
        this.setState({ dispositivos: resp.data });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.setState({
            error404: get(error, "response.data.data.message", "Não foi encontrado!"),
          });
        }
      });
  };

  message404 = () => (
    <tr>
      <td colspan="5">
        <div className="alert alert-warning text-center">{this.state.error404}</div>
      </td>
    </tr>
  );

  render() {
    return (
      <div>
        <div className="row">
          <button
            type="button"
            className="btn btn-link btn-action"
            onClick={this.props.showCompImei}
          >
            <i className="mdi mdi-keyboard-arrow-left"></i>
            Voltar
          </button>
          <h3 className="mt-3 ">Consulte o dispositivo por IMEI:</h3>
        </div>

        <p className="font-weight-light">
          Deseja consultar a situação de um dispositivo celular/smartphone por IMEI? Verifique
          abaixo:
        </p>

        <form className="form-inline form-consulta-imei">
          <div className="form-group text-field mr-2 mb-2">
            <input
              type="text"
              className="form-control"
              id="imei"
              placeholder="Digite o IMEI"
              onChange={(e) => this.setState({ imeiDisp: e.target.value })}
            />
          </div>
          <button type="submit" className="btn btn-primary mb-2" onClick={this.onConsultar}>
            Consultar
          </button>
        </form>
        <div>
          <div>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>IMEI Celular</th>
                  <th>CPF</th>
                  <th>Marca</th>
                  <th>Modelo</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody>{!this.state.error404 ? this.renderList() : this.message404()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default ConsultaImei;



// WEBPACK FOOTER //
// ./src/components/Home/ConsultaImei.js